import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Box, Image } from "@chakra-ui/react";
// Constants
const TRANSITION_DURATION = "1000ms";
const TRANSITION_EASING = "cubic-bezier(0.25, 0.46, 0.45, 0.94)";
const IMAGE_SLIDESHOW_INTERVAL = 4000;
export default function ImageSlideshowColumn({ images, columnIndex, columnWidth, onRefReady, }) {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const intervalRef = useRef(null);
    const timeoutRef = useRef(null);
    const slideshowStartDelay = columnIndex * 200;
    useEffect(() => {
        if (images.length <= 1) {
            // No slideshow needed if 1 or 0 images
            setCurrentImageIndex(0);
            return;
        }
        // Clear any existing interval/timeout
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        // Start with a staggered index based on column index
        const startIndex = columnIndex % images.length;
        setCurrentImageIndex(startIndex);
        // Start slideshow after a per-column delay so columns are out of sync,
        // but keep the same interval duration for all columns
        timeoutRef.current = setTimeout(() => {
            intervalRef.current = setInterval(() => {
                setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
            }, IMAGE_SLIDESHOW_INTERVAL);
        }, slideshowStartDelay);
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, [images, columnIndex, slideshowStartDelay]);
    return (_jsx(Box, { ref: (el) => onRefReady(el, columnIndex), position: "relative", w: columnWidth, h: "100vh", overflow: "hidden", flexShrink: 0, children: images.map((imageUrl, imgIndex) => (_jsx(Image, { src: imageUrl, alt: `Venue image ${imgIndex + 1}`, position: "absolute", top: 0, left: 0, w: "100%", h: "100%", objectFit: "cover", opacity: imgIndex === currentImageIndex ? 1 : 0, transition: `opacity ${TRANSITION_DURATION} ${TRANSITION_EASING}`, zIndex: imgIndex === currentImageIndex ? 1 : 0 }, `image-${columnIndex}-${imgIndex}`))) }));
}
